import { useEffect } from 'react';

import { useValueRef } from 'hooks/useValueRef';

import { SubmitInterceptor, useFormContext } from './FormContext';

type Props = {
  onIntercept: SubmitInterceptor;
};

/**
 * Allows performing actions such as updating a value before submitting the form.
 */
export function useFormSubmitInterceptor({ onIntercept }: Props) {
  const { addSubmitInterceptor } = useFormContext();

  const onInterceptRef = useValueRef(onIntercept);

  useEffect(
    // Remove when unmounted
    () => addSubmitInterceptor(() => onInterceptRef.current()),
    [addSubmitInterceptor, onInterceptRef],
  );
}

export function FormSubmitInterceptor({ onIntercept }: Props) {
  useFormSubmitInterceptor({ onIntercept });

  return null;
}
